var React = require('react');

function CarrotRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.47266 11L9.72266 8L6.47266 5","stroke":"#018DC0","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CarrotRight.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = CarrotRight;

CarrotRight.default = CarrotRight;
